import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const inspectionsNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Inspections,
  route: RoutesEnum.Inspections,
  icon: 'verified_user',
};
